import type { SVGProps } from "react";
import { Icon } from "./icon";

/** Access and field glyphs. Drawings live in the shared catalogue (`icon.tsx`). */
export type GlyphName = "lock" | "people" | "disabled" | "unavailable" | "calendar";

export function Glyph({
  name,
  className,
  ...props
}: {
  name: GlyphName;
  className?: string;
} & Omit<SVGProps<SVGSVGElement>, "viewBox" | "children" | "name">) {
  return <Icon name={name} className={className ? `glyph ${className}` : "glyph"} {...props} />;
}
